import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import type { Importer } from '@feathr/blackbox';
import { Button } from '@feathr/components';

interface IImporterAlertMessageProps {
  importer: Importer;
  onRefresh: () => void;
}

/** Each `Trans` sets `shouldUnescape`, or i18n and React both escape the name ("A &amp; B"). */
function ImporterAlertMessage({
  importer,
  onRefresh,
}: Readonly<IImporterAlertMessageProps>): JSX.Element | null {
  const { t } = useTranslation();
  const name = importer.get('name') || t('Unknown import');
  const refreshButton = (
    <>
      {' '}
      <Button onClick={onRefresh} type={'link'}>
        {t('Refresh partners')}
      </Button>
      .
    </>
  );

  switch (importer.get('state')) {
    case 'pending':

    case 'processing':
      return (
        <p>
          <Trans shouldUnescape={true} t={t}>
            Importing <em>{{ name }}</em> is in progress...
          </Trans>
        </p>
      );

    case 'complete':
      return (
        <p>
          <Trans shouldUnescape={true} t={t}>
            Importing <em>{{ name }}</em> has completed.
          </Trans>
          {refreshButton}
        </p>
      );

    case 'failed':
      return (
        <p>
          <Trans shouldUnescape={true} t={t}>
            Importing <em>{{ name }}</em> failed.
          </Trans>
          {refreshButton}
        </p>
      );

    case 'draft':
      return null;
  }
}

export default observer(ImporterAlertMessage);
